module.exports = "https://static.wagwalking.com/_next/static/images/happy-dog-2-30b4c7b40de08a7824b93efde1f6713f.svg";